import unreachableCaseError from "../util/unreachableCaseError.js";
export function getLogoSize(units) {
    switch (units) {
        case 2:
            return { width: 59, height: 32 };
        case 3:
            return { width: 80, height: 40 };
        case 4:
            return { width: 102, height: 48 };
        default:
            throw unreachableCaseError(units);
    }
}
//# sourceMappingURL=LogoShared.js.map